/**
 * Koz Featured Grid — mobile horizontal product slider (prev/next + scroll snap).
 */
(function () {
  function init(root) {
    var track = root.querySelector('[data-koz-fc-track]');
    var prev = root.querySelector('[data-koz-fc-prev]');
    var next = root.querySelector('[data-koz-fc-next]');

    if (!track) return;

    function getItems() {
      return track.querySelectorAll('.fc-grid__item');
    }

    function getStep() {
      var items = getItems();
      if (!items.length) return 0;
      if (items.length === 1) return items[0].offsetWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function updateButtons() {
      if (!prev || !next) return;
      var items = getItems();
      if (items.length < 2) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      prev.hidden = false;
      next.hidden = false;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function boot() {
    document.querySelectorAll('[data-koz-fc-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-koz-fc-slider]');
    if (root) init(root);
  });
})();
